import { TypeEntidadeDependencia } from "../Models/EntidadeDepedencia";
import { Axios } from "./Axios";


export class EntidadeDependenciaService {
    public listarDependencias(entidade: TypeEntidadeDependencia) {
        return Axios.post<TypeEntidadeDependencia[]>("EntidadeDependencia/listarDependencias", entidade);
    };
    public listarDependencia(entidade: TypeEntidadeDependencia){
        return Axios.post<TypeEntidadeDependencia>("EntidadeDependencia/listarDependencia", entidade);
    };
    public verficarEntidade(entidade: TypeEntidadeDependencia){
        return Axios.post<TypeEntidadeDependencia>("EntidadeDependencia/verficarEntidade", entidade);
    }
}